import type { ReactNode } from 'react';
import type { Crumb } from './section-trail';
import { Breadcrumbs } from './Breadcrumbs';

interface PageHeaderProps {
  title: string;
  /** The pages above this one (`sectionTrail` / `withinSection`). The title is added as the last, unlinked crumb. */
  breadcrumbs: Crumb[];
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, breadcrumbs, description, actions }: PageHeaderProps) {
  return (
    <header className="mb-8 flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        <div className="mb-1.5">
          <Breadcrumbs trail={breadcrumbs} current={title} />
        </div>
        <h1 className="text-2xl font-semibold tracking-tight text-fg">{title}</h1>
        {description && <p className="mt-1.5 max-w-2xl text-sm text-muted">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  );
}
